import { get, isNil } from "lodash";

export const getChildItemsWithTypename = (typename, item) => {
  if (isNil(item) || isNil(item.childItems)) {
    return undefined;
  }

  return item.childItems.filter(item => get(item, "__typename") === typename);
};
